import { Navigation as OriginalComponent } from './Navigation';

export const Navigation = OriginalComponent;



// WEBPACK FOOTER //
// ./app/components/Navigation/index.js